(function () {
	const searchModal = () => {
		$(".header__search .search__form-inner,.search-mobile-trigger").off("click.searchModal").on("click.searchModal",
			function (e) {
				if ($(this).closest(".search-modal.active").length) return;
				e.preventDefault();
				searchOpen();
			}
		);
		$(".search-modal__overlay,.search__close,.search-mobile-close").off("click.searchModal").on("click.searchModal",
			function (e) {
				e.preventDefault();
				searchClose();
			}
		);
	};
	$(document).on("keyup", function (e) {
		if ($(".search-modal").hasClass("active") && e.key == "Escape") {
			searchClose();
		}
	});
	function searchOpen() {
		$("#search-modal").addClass("active");
		$("#search-modal-mobile").addClass("active");
		const onMobile = !window.matchMedia("(min-width: 1100px)").matches;
		const modal = onMobile ? "#search-modal-mobile" : "#search-modal";
		const $header = $(".shopify-section-header");
		// Freeze the header first: the drawer is fixed inside it, see base.css.
		if (onMobile && $header.length) {
			const headerTop = Math.max(0, $header[0].getBoundingClientRect().top);
			$header[0].style.setProperty("--search-drawer-top", `${headerTop}px`);
		}
		$header.toggleClass("header--search-open", onMobile);
		$(modal).find(".search__input")[0]?.focus({ preventScroll: true });
		// The mobile drawer covers the whole screen, so the page behind it must never
		// scroll. iOS scrolls an unlocked page when the keyboard opens.
		if (!onMobile && $(".search-modal__overlay").hasClass("hide-overlay")) {
			$("body").removeClass("overflow-hidden");	
		} else {
			$("body").addClass("overflow-hidden");
		}
		if ($header.hasClass("header-overlay") && !$(".search-modal__overlay").hasClass("hide-overlay")) {
			$header.removeClass("color-inverse");
		}
	}
	function searchClose() {
		$("#search-modal").removeClass("active");
		if ($("#search-modal").hasClass("active")) {
			$("#search-modal").find(".search__input")[0].focus();
		} else {
			$(".search-modal-trigger").focus();
		}
		$("#search-modal-mobile").removeClass("active");
		if ($("#search-modal-mobile").hasClass("active")) {
			$("#search-modal-mobile").find(".search__input")[0].focus();
		} else {
			$(".search-modal-trigger").focus();
		}
		const element = $(".search-modal__form-main");
		const sec = $(".predictive-search__wrapper");
		if (element.length) {
			if (element.attr("open") !== undefined) {
				element[0].removeAttribute('open');
			}
		}
		$("body").removeClass("overflow-hidden");
		const $header = $(".shopify-section-header");
		$header.removeClass("header--search-open");
		if ($header.hasClass("header-overlay") && !$header.hasClass("shopify-section-header-sticky")) {
			$header.addClass("color-inverse");
		}
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
